module.exports = __webpack_public_path__ + "media/metronic/_theme/media/plugins/jstree/32px-cab7780c04c84ef9ed3207f8f12f1287.png";